export class GeneralEquipmentsGroup {
    id: string;
    name: string;
    listOfGeneralEquipment: Array<string>;
}
